export class BasicAsyncEnumerable {
    iterator;
    constructor(iterator) {
        this.iterator = iterator;
    }
    [Symbol.asyncIterator]() {
        return this.iterator();
    }
}
